var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnouncements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0801735 4.01012C0.0280551 4.17944 0 4.35931 0 4.54572V15.4548C0 16.459 0.814028 17.273 1.81818 17.273H18.1818C19.186 17.273 20 16.459 20 15.4548V4.54572C20 4.3593 19.9719 4.17943 19.9198 4.01011C19.8696 4.12169 19.7959 4.22488 19.6991 4.31199L11.8244 11.3991C10.7872 12.3326 9.21274 12.3326 8.17555 11.3991L0.300938 4.31199C0.204146 4.22488 0.130423 4.12169 0.0801735 4.01012ZM18.7167 2.80749C18.5476 2.75552 18.368 2.72754 18.1818 2.72754H1.81818C1.63202 2.72754 1.4524 2.75552 1.28328 2.8075C1.36662 2.84515 1.44564 2.89611 1.51724 2.96055L9.39185 10.0477C9.73758 10.3589 10.2624 10.3589 10.6081 10.0477L18.4828 2.96055C18.5544 2.89611 18.6334 2.84514 18.7167 2.80749Z",
    fill: "#006CFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncements);
export default __webpack_public_path__ + "static/media/announcements.decbf1b5d8ffdf1f3c488fa26fd43655.svg";
export { ForwardRef as ReactComponent };